import { Link } from "react-router-dom";
import { FaHome, FaExclamationTriangle } from "react-icons/fa";
import NavBar from "../components/NavBar";

function NotFound() {
  return (
    <div className="App">
      <NavBar />
      
      <main className="dashboard">
        <div className="container">
          <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 200px)' }}>
            <div className="card text-center" style={{ maxWidth: '500px', padding: '3rem' }}>
              <div className="card-body">
                <div style={{ fontSize: '5rem', color: 'var(--warning-500)', marginBottom: '2rem' }}>
                  <FaExclamationTriangle />
                </div>
                <h1 style={{ fontSize: '4rem', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '1rem' }}>
                  404
                </h1>
                <h2 className="card-title" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
                  Page Not Found
                </h2>
                <p className="card-description" style={{ marginBottom: '2rem' }}>
                  The page you're looking for doesn't exist or has been moved. Let's get you back on track.
                </p>
                
                <Link className="btn btn-primary btn-lg" to="/">
                  <FaHome />
                  Back to Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default NotFound;
